onReady(($) => {
    $(".case-study-slider")
        .each((index, module) => {
            var numberOfSlides = 1;
            if ($(module)
                .hasClass("three-visible-cards")) {
                numberOfSlides = 3;
            }
            else if ($(module)
                .hasClass("two-visible-cards")) {
                numberOfSlides = 2;
            }

            $(".case-study-slider-container", module)
                .slick({
                    slidesToShow: numberOfSlides,
                    slidesToScroll: 1,
                    arrows: true,
                    nextArrow: '<div class="slick-arrow next" title="next-card"></div>',
                    prevArrow: '<div class="slick-arrow prev" title="previous-card"></div>',
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 1049,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                arrows: false,
                            },
                        },
                        {
                            breakpoint: 660,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                            },
                        },
                    ],
                });
        });
});
